import React from 'react';
import "./index.scss";
import { useIntl, history } from 'umi';
import Default from '@/pages/home/assets/svg/dashboard/default.svg';
import DefaultDisable from '@/pages/home/assets/svg/dataSource/socialmedia.svg';
import { getTranslatedText } from '@/pages/dashboard/utils/getTranslatedText';
import dataFormat from '@home/utils/dbDataFormat/dataFormat';
import classNames from 'classnames';
import ACard from '../ACard';

export type RankDataType = {
  // 值
  value: string | number;
  // 总占比
  subValue: string | number;
  // 中英文名称
  nameEn: string;
  nameCn?: string;
  // 图标
  icon?: string;
  disableIcon?: string;
  // 占比条颜色
  color?: string;
  // 排行榜只展示平台数据或占比 value | subValue
  valueDisplayMode?: string;
  // 是否是黑色图片
  isBlackImg?: boolean;
  // 跳转链接
  link: string;
  // 打开新窗口连接
  windowLink?: string;
}

interface IMetricsCardRank {
  // 类名
  className?: string;
  // 样式
  style?: React.CSSProperties;
  // 数据
  data: RankDataType[];
  // 值的格式
  formatRule?: string;
  // 值的小数位
  subFormatRule?: string;
}

const DEFAULT_COLORS = [
  '#5EC8F1'
];

const MetricsCardRank: React.FC<IMetricsCardRank>  = (props) => {
  const { className = '', style = {}, data, formatRule = 'thousandsInit', subFormatRule = 'absPercent1Decimal' } = props;

  const { locale } = useIntl();
  
  return (
    <div className={`${className}`} style={style}>
      {data?.map((progress: RankDataType, index: number) => {
        const {
          nameEn,
          nameCn = '',
          value: progressValue,
          subValue,
          icon: progressIcon,
          disableIcon,
          color,
          valueDisplayMode,
          isBlackImg = false,
          link,
          windowLink,
        } = progress || {};

        const title = getTranslatedText(nameEn, nameCn, locale);
        const hasLink = typeof link === 'string' ? link.trim() !== '' : link;
        // 点击卡片跳转页面
        const jumpToLink = () => {
          if (!hasLink) return;
          if (typeof link === 'string') {
            history.push(link);
          } else {
            link?.();
          }
        };      
        const formattedValue = dataFormat({value: progressValue, formatRule});
        const isNoValue = formattedValue === '-';

        const formattedPercent = dataFormat({value: subValue, formatRule: subFormatRule});

        const icon = isNoValue ? disableIcon || progressIcon || DefaultDisable : progressIcon || Default;
        const isDefaultIcon = icon === DefaultDisable;
        const displayModeMap: Record<string, string> = {
          subValue: formattedPercent ? `${formattedPercent}` : '-',
          value: formattedValue as string  || '-',
        };
        
        const displayValue = valueDisplayMode ? displayModeMap[valueDisplayMode] : undefined;
  
        const value = formattedValue + (!isNoValue ? ` (${formattedPercent})` : '');

        // 占比条颜色，优先级: 适配颜色 > 默认色组
        const barColor = color || DEFAULT_COLORS[index % (DEFAULT_COLORS.length - 1)] || '#5EC8F1';

        return (
          <div
            className={classNames('dbd-metrics-card-rank', {
              'disable': isNoValue,
              'opacity': isNoValue && isDefaultIcon
            })}
            key={index}
          >
            <img 
              className={classNames("dbd-metrics-card-rank-img",{ 'dbd-metrics-card-rank-img-dark': isBlackImg || isNoValue || icon === Default })}
              src={icon}
            />
            <div className={`dbd-metrics-card-rank-data ${isNoValue ? 'disable' : ''}`}>
              <div className="dbd-metrics-card-rank-flex">
                <ACard url={windowLink} className="dbd-metrics-card-rank-a-card">
                  <div className="dbd-metrics-card-rank-title" onClick={hasLink ? jumpToLink : undefined}>
                    {title}
                  </div>
                </ACard>
                {displayValue || value}
              </div>
              <div className="dbd-metrics-card-rank-box">
                <div
                  className="dbd-metrics-card-rank-bg"
                  style={{
                    width: isNoValue ? undefined : `${formattedPercent}`,
                    background: isNoValue ? undefined : barColor,
                  }}
                />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default MetricsCardRank;
